import { StreemAPI } from '@streem/api';
import { invariant } from '@streem/toolbox';
import { logger } from '../../util/logger';
class BaseSyncClientCred {
    getWallCreds() {
        invariant(this.wallCreds, 'wallCreds must be defined. Make sure to call fetch() first.');
        return this.wallCreds;
    }
    disconnect() {
        this.wallCreds = undefined;
        this.inProgressFetch = undefined;
    }
}
class UserSyncClientCred extends BaseSyncClientCred {
    async fetch(userId) {
        if (this.inProgressFetch === undefined) {
            this.inProgressFetch = this.createUserToken(userId)
                .then(data => {
                let wallCredsData;
                if (data.twilioSync) {
                    wallCredsData = data.twilioSync;
                }
                else if (data.streemWall) {
                    wallCredsData = data.streemWall;
                }
                invariant(wallCredsData?.mapName, 'mapName must exist on user token data');
                invariant(wallCredsData?.token, 'token must exist on user token data');
                this.wallCreds = {
                    mapName: wallCredsData.mapName,
                    token: wallCredsData.token,
                    syncService: data.twilioSync ? 'twilio' : 'streem',
                };
            })
                .catch(err => {
                logger.error('Error fetching user token.', err);
                this.wallCreds = undefined;
            })
                .finally(() => {
                this.inProgressFetch = undefined;
            });
        }
        await this.inProgressFetch;
    }
    async createUserToken(userId) {
        logger.info(`Creating new User Token for userId=${userId}`);
        const { userWallCredentials } = await StreemAPI.users.createUserTokens(userId.toString());
        invariant(userWallCredentials, 'User Wall Credentials must be defined');
        return userWallCredentials;
    }
}
class RoomWallSyncClientCred extends BaseSyncClientCred {
    toMapName(roomSid) {
        return `${roomSid}:wall`;
    }
    async fetch(roomId, userId, readOnly) {
        if (this.inProgressFetch === undefined) {
            this.inProgressFetch = this.createRoomWallToken(roomId, userId, readOnly)
                .then(data => {
                this.wallCreds = data;
            })
                .catch(err => {
                logger.error('Error fetching room wall token.', err);
                this.wallCreds = undefined;
            })
                .finally(() => {
                this.inProgressFetch = undefined;
            });
        }
        await this.inProgressFetch;
    }
    async createRoomWallToken(roomSid, userId, readOnly) {
        let wallCredentials;
        let syncService;
        if (readOnly) {
            const credResponse = await StreemAPI.rooms.createReadonlyRoomToken(roomSid.toString());
            wallCredentials = credResponse.streemRoomCredentials;
            syncService = 'twilio';
        }
        else {
            invariant(userId, 'Expected userId to be defined when creating room wall write token');
            const credResponse = await StreemAPI.rooms.createRoomWallCredentials(roomSid.toString(), userId.toString());
            if (credResponse.twilioRoomWallCredentials) {
                wallCredentials = credResponse.twilioRoomWallCredentials;
                syncService = 'twilio';
            }
            else if (credResponse.streemRoomWallCredentials) {
                wallCredentials = credResponse.streemRoomWallCredentials;
                syncService = 'streem';
            }
        }
        invariant(wallCredentials, 'Streem Room Credentials must be defined');
        invariant(wallCredentials?.roomSid, 'roomSid must exist on room wall token data');
        invariant(wallCredentials?.token, 'token must exist on room wall token data');
        invariant(syncService, 'wallType must be defined');
        return {
            mapName: this.toMapName(wallCredentials.roomSid),
            token: wallCredentials.token,
            syncService: syncService,
        };
    }
}
class WallTokenUtil {
    constructor() {
        this.userClientCred = new UserSyncClientCred();
        this.roomWallClientCred = new RoomWallSyncClientCred();
    }
}
export default new WallTokenUtil();
//# sourceMappingURL=wall_token_util.js.map